import { render, staticRenderFns } from "./orderdetail2.vue?vue&type=template&id=3ac3b056&scoped=true&"
import script from "./orderdetail2.vue?vue&type=script&lang=js&"
export * from "./orderdetail2.vue?vue&type=script&lang=js&"
import style0 from "./orderdetail2.vue?vue&type=style&index=0&id=3ac3b056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac3b056",
  null
  
)

export default component.exports